import styled, { css } from 'styled-components';

export const rightAlign = css`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 0.3em;
`;

export const noResultImage = css`
  width: 222px;
  height: 194px;
  margin: 40px auto 0px;
`;

export const noResultDescription = css`
  text-align: center;
`;

export const filterResultsContainer = css`
  display: flex;
  flex-direction: column;
`;

export const filterResultsRow = css`
  display: flex;
  flex-direction: row-reverse;
  font-size: clamp(1rem, 3vw + 0.25rem, 1.2rem);
`;

export const searchText = css`
  width: fit-content;
`;

export const clearLink = css`
  margin-inline-start: 42px;
  text-decoration: underline var(--DustyGray);
  &:hover {
    text-decoration-thickness: 2px;
  }
`;

export const articleGrid = css`
  display: grid;
  --columns: 2;
  grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
  align-items: stretch;
  grid-gap: 16px;

  div.featured-article-grid {
    grid-column: 1/-1;
  }

  @media (max-width: 794px) {
    --columns: 1;
  }
`;

export const FeatureArticleWrapper = styled.div`
  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    grid-column: 1/-1;

    @media (min-width: 768px) {
      > a {
        max-height: unset;
      }
    }

    @media (min-width: 795px) {
      > a {
        min-height: 400px;
        height: unset;
        align-items: stretch;

        > div {
          height: unset;
        }
      }
    }
  }
`;

export const SearchedTermWrapper = styled.div`
  text-align: center;

  h3 {
    margin-bottom: 0;
  }
`;

export const galleryCSS = css`
  background-color: var(--gallery);
`;

type PaginatorWrapperProps = {
  isSecondLanguageOn: boolean;
};

export const PaginatorWrapper = styled.div<PaginatorWrapperProps>`
  padding-top: 40px;
  padding-bottom: 10px;

  ul {
    justify-content: center;

    li {
      :first-child,
      :last-child {
        transform: ${({ isSecondLanguageOn }) =>
          isSecondLanguageOn ? 'scaleX(-1)' : 'unset'};
      }
    }
  }
`;

export const breadcrumbWrapper = css`
  svg {
    height: 18px;
  }
`;

export const TextInputWrapper = styled.div`
  [class*='FieldWrapperstyle__FieldWrapper-sc'] {
    #searchInput-text-input {
      width: 50%;
    }
    @media (max-width: 1024px) {
      #searchInput-text-input {
        width: 100%;
      }
    }
  }
`;

export const FilterContainer = styled.div`
  display: grid;
  gap: 1.25rem;

  @media (min-width: 1025px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const FilterButtonsContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 376px) {
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1025px) {
    display: flex;
  }

  gap: 1.25rem;
`;

export const SearchInputWrapper = styled.div<{
  direction: 'rtl' | 'ltr';
  inputWidth: string;
}>`
  width: ${props => props.inputWidth};

  @media (max-width: 1024px) {
      width: 100%;
    }
    ${props =>
      props.direction === 'rtl' &&
      css`
        [class*='Interactionstyle__Button-sc'] {
          border-radius: 6px !important;
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }
        [class*='TextInputstyle__TextInput-sc'] {
          border-radius: 6px !important;
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
          border-left-width: 0 !important;
          border-left-style: none !important;
          border-right-width: 1px !important;
          border-right-style: solid !important;
          padding-right: 12px !important;
          padding-left: 36px !important;
        }
        [class*='SearchTextInputstyle__InteractionIcons-sc'] {
          padding-right: 0 !important;
          padding-left: 12px !important;
          right: unset !important;
          left: 0 !important;
        }
      `};
`;
